import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getCurrentUser, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { EtiquetaNog, EtiquetasGestionService } from '../../services/etiquetas-gestion.service';

@Component({
  selector: 'app-etiquetas-gestion',
  templateUrl: './etiquetas-gestion.component.html',
  styleUrls: ['./etiquetas-gestion.component.scss']
})
export class EtiquetasGestionComponent {

  recordsToSend: number = 1000; //--> Numero de registros que se enviarán en cada request
  reader = new FileReader();
  isFileLoaded: boolean = false
  textFileLoaded: String
  lastTextFileLoaded: String
  csvMatriz: string[] = [];
  csvHeader: string[] = [];
  parsedInfo: any[] = []
  incorrectInfo: any[] = []
  inputFile: HTMLInputElement
  isResend: boolean = false

  form: FormGroup = new FormGroup({
    option: new FormControl("", [Validators.required]),
  })

  constructor(private _notificationService: NotificationHelper,
    private _etiquetasGestionService: EtiquetasGestionService,
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
  ) {
    // --> capturamos el usuario y la conexión
    let localUser = getCurrentUser();
    localUser = localUser && typeof localUser == "string" ? JSON.parse(localUser) : null;
    // --> cuando se cargue un archivo, se procesará de la siguiente forma:
    this.reader.addEventListener('load', (event) => {
      showSpinner()
      this.textFileLoaded = this.reader.result ? this.reader.result as string : "";
      this.csvMatriz = this.textFileLoaded.split(/\r\n|\n/)
      try {
        this.onLoadFile()
      } catch (error: any) {
        this._notificationService.errorMessage(error.message)
      }
      hideSpinner()
    });
    const data = this.activatedRoute.snapshot.data
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
  }

  onSelectFile(e: HTMLInputElement) {
    this.disableButtonAndDeleteLoadedInfo()
    showSpinner()
    this.inputFile = e
    const files = this.inputFile.files;
    if (files && files.length) {
      this.reader.readAsText(files[0]);
    } else {
      this._notificationService.errorMessage("No se seleccionó ningún archivo.");
    }
    hideSpinner()
  }

  /**
   * Cuando se carga el archivo transformamos los datos en un arreglo de tipo etiquetaNog
   */
  onLoadFile() {
    showSpinner()
    if (this.csvMatriz == undefined || this.csvMatriz.length <= 0) {
      throw new Error("Este archivo no contiene datos.");
    }
    //Sacar el primer registro (debe contener los encabezados)
    const shift = this.csvMatriz.shift()
    if (!shift) {
      throw new Error("Error eliminando encabezados")
    }
    //Obtenemos el header
    this.csvHeader = shift.split(";");
    //Evaluamos que los encabezados sean correctos
    if (!(this.csvHeader[0].toUpperCase() == "C_AGR" &&
      this.csvHeader[1].toUpperCase() == "T_CRE" &&
      this.csvHeader[2].toUpperCase() == "CUE" &&
      this.csvHeader[3].toUpperCase() == "N_IDE" &&
      this.csvHeader[4].toUpperCase() == "ORIGEN")) {
      throw new Error("Este archivo no tiene el formato requerido.")
    }
    if (this.csvMatriz.length <= 0) {
      throw new Error("El archivo tiene el formato, pero no tiene registros.");
    }

    //Parseamos la información en el tipo JSON
    this.csvMatriz.forEach((value, index) => {
      //Separamos los valores por ";"
      const split = value.split(";")
      //Creamos un objeto de validación
      if (split.length == 5) {
        const item: EtiquetaNog = {
          c_emp: getConnection(),
          c_agr: split[0] ? split[0] : "",
          t_cre: split[1] ? split[1] : "",
          cue: split[2] ? split[2] : "",
          n_ide: split[3] ? split[3] : "",
          origen: split[4] ? split[4] : "",
        }
        if (item.c_agr && item.t_cre && item.cue && item.n_ide) {
          this.parsedInfo.push(item);
        } else {
          this.incorrectInfo.push(item)
        }
      }

    });
    //Activamos el boton de envio
    this._notificationService.infoMessage(`Se encontraron ${this.parsedInfo.length} registros.`)
    this.enableSendButton()
    hideSpinner()
  }

  disableButtonAndDeleteLoadedInfo() {
    this.parsedInfo = [];
    this.csvMatriz = [];
    this.csvHeader = [];
    this.isFileLoaded = false;
    this.incorrectInfo = []
  }

  enableSendButton() {
    this.isFileLoaded = true;
  }

  async submit(resend: any[] = []): Promise<void> {
    showSpinner()
    if (resend.length > 0) {
      await this.eachRequests(resend)
    } else if (this.parsedInfo.length > 0) {
      // this.parsedInfo = this.parsedInfo.slice(0, 4000);
      const divisor = this.parsedInfo.length / this.recordsToSend;
      let dividedData: any[] = []

      this._notificationService.infoDialog("Info", "No abandones la página hasta que el proceso finalice")

      for (let i = 0; i < divisor; i++) {
        const element = this.parsedInfo.slice(i * this.recordsToSend, (i + 1) * this.recordsToSend);
        dividedData.push(element)
      }

      const result = await this.eachRequests(dividedData)
      if (result.success) {
        this._notificationService.successMessage(result.message)
        this.disableButtonAndDeleteLoadedInfo()
      } else {
        this._notificationService.errorMessage(result.message)
      }
    } else {
      this._notificationService.infoMessage("No hay nada que enviar")
    }
    this.inputFile.value = ""
    hideSpinner()
  }

  async eachRequests(data: any[]) {
    showSpinner()
    let response: BasicResponse = new BasicResponse(false, "Aún no se realiza el request")
    /**
     * Realizamos los respectivos request
     */
    for (let i = 0; i < data.length; i++) {
      const etiquetas = data[i];
      response = await this.enviarEtiquetas(etiquetas);
      /**
      * Si el request no salió bien se almacena en localStorage
      * para decirle al usuario que los envíe de nuevo si así lo desea
      */
      if (!response.success) {
        this._notificationService.errorMessage(response.message)
        break;
      }
    }
    hideSpinner()
    return response
  }

  async enviarEtiquetas(etiquetas: EtiquetaNog[]) {
    showSpinner()
    let result: BasicResponse = new BasicResponse(false, "Todavía no se hizo el request")
    if (this.form.get("option")?.value == 1) {
      result = await this._etiquetasGestionService.activarEtiquetasNog(etiquetas);
    } else {
      result = await this._etiquetasGestionService.desactivarEtiquetasNog(etiquetas)
    }
    hideSpinner()
    return result
  }

}